import React from 'react';
import PropTypes from 'prop-types';

import ProblemTriangle from '@zg-rentals/multibrand-ui/lib/icons/ProblemTriangle';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';

import PaidInclusionConstants from 'app/shared/constants/PaidInclusionConstants';

import './style.scss';

const PaidInclusionError = ({
    paymentFailErrorMessage,
    paymentPendingErrorMessage,
    initiateCardCaptureErrorMessage,
    verifyPaymentAndActivateListingErrorMessage,
    defaultErrorMessage,
    isRenderedInPageView,
}) => {
    const maintenanceModeErrorMessage = PaidInclusionConstants.ERROR_TYPE.METROID_MAINTENANCE_MODE;
    const isMaintenanceMode = paymentFailErrorMessage === maintenanceModeErrorMessage
        || initiateCardCaptureErrorMessage === maintenanceModeErrorMessage
        || verifyPaymentAndActivateListingErrorMessage === maintenanceModeErrorMessage;

    return (
        <div className="PaidInclusionError">
            <SpacerRow className={`PaidInclusionError-header ${isRenderedInPageView ? '' : 'modalViewMargin'}
                ${isMaintenanceMode ? 'maintenanceMode' : ''}`}
            >
                <ProblemTriangle colorType="inverse" size={100} />
            </SpacerRow>
            <SpacerRow size="lg" className="PaidInclusionError-body">
                <Text type="body">
                    {initiateCardCaptureErrorMessage || paymentFailErrorMessage
                || paymentPendingErrorMessage || verifyPaymentAndActivateListingErrorMessage || defaultErrorMessage}
                </Text>
            </SpacerRow>
            <SpacerRow className="ModalActions PaidInclusionError-actions">
                <Button full={true} type="outline" onClick={() => location.reload()}>
                    Reload page
                </Button>
            </SpacerRow>
        </div>
    );
};

PaidInclusionError.defaultProps = {
    defaultErrorMessage: PaidInclusionConstants.ERROR_TYPE.DEFAULT,
};

PaidInclusionError.propTypes = {
    paymentFailErrorMessage: PropTypes.string.isRequired,
    paymentPendingErrorMessage: PropTypes.string.isRequired,
    initiateCardCaptureErrorMessage: PropTypes.string.isRequired,
    defaultErrorMessage: PropTypes.string,
    isRenderedInPageView: PropTypes.bool.isRequired,
};

export default PaidInclusionError;
